module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8682/img/blobsRight.png"